"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateInput = void 0;
const React = require("react");
const _ = require("lodash");
const moment = require("moment");
const HStack_1 = require("../../structure/HStack");
const SingleOptionsInput_1 = require("../SingleOptionsInput");
const dateStringToObject_1 = require("./helpers/dateStringToObject");
const padNumber_1 = require("./helpers/padNumber");
const getApplicableDateSegments_1 = require("./helpers/getApplicableDateSegments");
const dateStringMatchesFormatString_1 = require("./helpers/dateStringMatchesFormatString");
const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const monthOptions = months.map((m, i) => {
    return { value: (0, padNumber_1.padNumber)(i + 1), label: m };
});
const days = _.times(31, n => (0, padNumber_1.padNumber)(n + 1));
/**
 * Renders a date selector
 */
class DateInput extends React.Component {
    constructor(props) {
        super(props);
        // Called on input change
        this.dateElementChange = (key, value) => {
            this.setState({ [key]: value }, this.informParentThroughCallback);
        };
        // Called by 'today' button
        // setToToday() {
        //   this.setState({
        //     year: moment().year(),
        //     month: padNumber(moment().month() + 1),
        //     day: padNumber(moment().date())
        //   });
        //   this.informParentThroughCallback();
        // }
        //
        this.stateToDate = () => {
            // Will only update the state with the inputs that are in dateFormat
            return ["year", "month", "day"]
                .filter(x => this.applicableDateSegments[x])
                .map(x => this.state[x])
                .join("-");
        };
        this.informParentThroughCallback = () => {
            // Avoid responding to out own update to avoid clearing all fields in some circumstances
            this.props.onInputChange(this.stateToDate());
        };
        const { value, dateFormat, minDate, maxDate } = this.props;
        if (!dateFormat) {
            throw new Error("dateFormat is required");
        }
        if (value && !(0, dateStringMatchesFormatString_1.dateStringMatchesFormatString)(value, dateFormat)) {
            throw new Error("date does not match format");
        }
        if (minDate && !(0, dateStringMatchesFormatString_1.dateStringMatchesFormatString)(minDate, dateFormat)) {
            throw new Error("min date does not match format");
        }
        if (maxDate && !(0, dateStringMatchesFormatString_1.dateStringMatchesFormatString)(maxDate, dateFormat)) {
            throw new Error("max date does not match format");
        }
        // Determine what types of data to collect
        this.applicableDateSegments = (0, getApplicableDateSegments_1.getApplicableDateSegments)(dateFormat);
        this.state = (0, dateStringToObject_1.dateStringToObject)(value, dateFormat);
        this.maxDateObject = maxDate
            ? moment(maxDate, dateFormat, true)
            : moment().add(100, "year");
        this.minDateObject = minDate
            ? moment(minDate, dateFormat, true)
            : moment().subtract(100, "year");
        const now = moment(moment().format(dateFormat), dateFormat);
        // min or max are not the current date, we default the other side of the scale to now.
        if (maxDate && this.maxDateObject.diff(now) > 0 && !minDate) {
            this.minDateObject = now;
        }
        if (minDate && this.minDateObject.diff(now) < 0 && !maxDate) {
            this.maxDateObject = now;
        }
        if (maxDate < minDate) {
            throw new Error("MinDate cannot be greater then MaxDate");
        }
        const yearRange = this.maxDateObject.year() - this.minDateObject.year();
        this.years = _.times(yearRange + 1, n => (this.maxDateObject.year() - n).toString());
        // determine where the placeholder is
        this.emptyOptionsIndex = 0;
        if (this.maxDateObject.year() > moment().year()) {
            this.emptyOptionsIndex = this.maxDateObject.year() - moment().year() + 1;
        }
    }
    componentWillReceiveProps(nextProps) {
        // use DateStringToObject - check if compatible, if not return empty strings
        // Avoid clearing all inputs when the update was caused by ourselves. This could happen if full
        // date has one of its parts cleared and we don't want to clear the other parts automatically
        const normalisedValue = nextProps.value === null ? "" : nextProps.value;
        if (normalisedValue === this.stateToDate())
            return;
        this.setState((0, dateStringToObject_1.dateStringToObject)(normalisedValue, this.props.dateFormat));
    }
    render() {
        return (React.createElement("div", { "data-test": "date-input", "data-test-date-format": this.props.dateFormat, "data-test-month-array": months },
            React.createElement(HStack_1.HStack, null,
                this.applicableDateSegments.day ? (React.createElement("span", { "data-test": "date-input-day" },
                    React.createElement(SingleOptionsInput_1.SingleOptionsInput, { options: days, value: this.state.day, variant: "dropdown", fieldName: "Day", placeholder: "Day", key: "day", onInputChange: (data) => this.dateElementChange("day", data), disabled: this.props.disabled }))) : null,
                this.applicableDateSegments.month ? (React.createElement("span", { "data-test": "date-input-month" },
                    React.createElement(SingleOptionsInput_1.SingleOptionsInput, { options: monthOptions, value: this.state.month, variant: "dropdown", fieldName: "Month", placeholder: "Month", key: "month", onInputChange: (data) => this.dateElementChange("month", data), disabled: this.props.disabled }))) : null,
                this.applicableDateSegments.year ? (React.createElement("span", { "data-test": "date-input-year" },
                    React.createElement(SingleOptionsInput_1.SingleOptionsInput, { options: this.years, value: this.state.year, variant: "dropdown", fieldName: "Year", placeholder: "Year", placeholderIndex: this.emptyOptionsIndex, key: "year", onInputChange: (data) => this.dateElementChange("year", data), disabled: this.props.disabled }))) : null)));
    }
}
exports.DateInput = DateInput;
//# sourceMappingURL=index.js.map